import { connect } from 'react-redux';
import LastStep6 from './LastStep6';
import { editBatchApplySequence } from '../../store/sequencingWizardSlice';

export default connect(null, { editBatchApplySequence })(LastStep6);
